import ContactToken from '@apps/crm/admin/tokens/contact'
import Page from '@admin/components/page'
import pluralize from 'pluralize'
import moment from 'moment'
import React from 'react'

const toDays = (date) => {
  const diff = Math.ceil(moment(date).diff(moment(), 'hours') / 24)
  const days = pluralize('day', Math.abs(diff), true)
  return diff === 0 ? 'today' : diff > 0 ? `in ${days}` : `${days} ago`
}

const mapPropsToPage = (props, context) => ({
  title: 't(Subscriptions)',
  collection: {
    endpoint: '/api/admin/dashboards/affiliate_subscriptions',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Contact)', key: 'subscription.contact.display_name', sort: 'last_name', primary: true, format: ({ subscription }) => {
        return <ContactToken { ...subscription.contact } />
      } },
      { label: 't(Organization)', key: 'subscription.position.organization', sort: 'organization' },
      { label: 't(Type)', key: 'type' },
      { label: 't(Plan)', key: 'plan.title', sort: 'plan' },
      ... props.query.subscription_type === 'regular' ? [
        { label: 't(Price)', key: 'price', format: 'currency' }
      ] : props.query.subscription_type === 'trial' ? [
        { label: 't(Trial Ends)', key: 'end_on', align: 'right', format: (trial) => (
          <>{ moment(trial.end_on).format('MM/DD/YY') } ({ toDays(trial.end_on) })</>
        ) }
      ] : []
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'check',
      title: 't(No Subscriptions)',
      text: 't(There are not any subscriptions for this time period)'
    },
    entity: 'subscription'
  }
})

export default Page(null, mapPropsToPage)
